export default __webpack_public_path__ + "static/media/idreport.3f98a15b.png";